import "./CheckBoxGroup.css";
import { useState } from "react";

// Función para quitar tildes de una cadena de texto

const CheckBoxGroup = ({ data, onChange }) => {
  const [localData, setLocalData] = useState(data);

  const handleChange = (itemSeleccionado) => {
    const newData = localData.map((item) =>
      item.id === itemSeleccionado.id
        ? { ...item, checked: !item.checked }
        : item
    );
    let allUncheckedExceptTodos = false;

    // Si "Todos" no es el checkbox cambiado, ajustar el estado de "Todos"
    if (itemSeleccionado.id !== 0) {
      allUncheckedExceptTodos = newData.slice(1).every((item) => !item.checked);
      newData[0].checked = allUncheckedExceptTodos;
    } else {
      // Si "Todos" es el checkbox cambiado, actualizar todos los checkboxes a su estado
      newData.forEach((item) => {
        if (item.id !== 0) {
          item.checked = !newData[0].checked;
        }
      });
    }

    setLocalData(newData);
    onChange(newData);
  };

  return (
    <div className="ptur-checkBoxGroup-container">
      {localData?.map((item, index) => (
        <div
          key={index}
          className={`ptur-checkBoxGroup-container-column ${
            index === 0 ? "margin-10px" : ""
          }`}
        >
          {/* <ItemCheckBoxGroup
            id={item.id}
            checked={item.checked}
            onChange={() => handleChange(item)}
            type={index === 0 ? "MENOS" : ""}
          /> */}
          <label
            className={`checkbox-containerKin`}
            key={index + item.descripcion}
          >
            <input
              type="checkbox"
              checked={item.checked}
              onChange={() => handleChange(item)}
              className="hidden-checkboxKin"
            />
            <div className="custom-checkboxKin">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 12L10 16L18 8" /* Define el trazo del tilde */
                  className="checkbox-pathKin"
                />
              </svg>
            </div>
            <span className="rb14l">{item.descripcion}</span>
          </label>

          {/* <span>{item.descripcion}</span> */}
        </div>
      ))}
    </div>
  );
};

export default CheckBoxGroup;
